import React, { useState, useEffect, Fragment } from 'react';
import SwiperCore, { Autoplay } from 'swiper';
import Button from '@material-ui/core/Button';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/scrollbar/scrollbar.scss';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import fox from './fox.svg';
import Swiper from 'swiper';
import './style.css';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IconButton from '@material-ui/core/IconButton';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Review from './Review';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Favorite from '@material-ui/icons/Favorite';
import FavoriteBorder from '@material-ui/icons/FavoriteBorder';
import logo from './securityplus.png';
import KeyboardEventHandler from 'react-keyboard-event-handler';

const data = require('./data.json');
SwiperCore.use([ Autoplay ]);

let reviewList = [];
const App = () => {
	const [ isVisible, setIsVisible ] = useState(false);
	const [ currentId, setCurrentId ] = useState(0);
    const [ review, setReview ] = useState(false);
    const [menu, setMenu] = useState("0-50")
    const firstId = {"0-50": 0, "51-100": 50, "101-150":100, "151-200": 150, "201-250": 200, "251-300":250, "301-350": 300, "351-400": 350, "401-450":400, "450-481":450}
    const handleMenu = (key) =>{
        setCurrentId(0)
        setProgress(0);

        if (reviewList.indexOf((firstId[key]).toString()) !== -1) {
            setReview(true);
        } else {
            setReview(false);
        }
        setMenu(key)
        initOption()
    }
	const handleReviewChange = (event, id) => {
		event.target.checked ? reviewList.push(id) : removeItem(id);
		setReview(event.target.checked);
	};

	const LinearProgressWithLabel = (props) => {
		return (
			<Box display="flex" alignItems="center">
				<Box width="100%" mr={1}>
					<LinearProgress variant="determinate" {...props} />
				</Box>
				<Box minWidth={35}>
					<Typography variant="body2" color="textSecondary">{`${currentId + 1}/${data[menu].length}`}</Typography>
				</Box>
			</Box>
		);
	};

	const removeItem = (id) => {
		var index = reviewList.indexOf(id);
		if (index !== -1) {
			reviewList.splice(index, 1);
		}
	};

	const [ progress, setProgress ] = useState(0);

	const prev = () => {
		if (currentId > 0) {
			if (reviewList.indexOf((currentId - 1).toString()) !== -1) {
				setReview(true);
			} else {
				setReview(false);
			}
            setCurrentId(currentId - 1);
			setProgress((currentId - 1) / data[menu].length * 100);
        }
        initOption()
	};

	const next = () => {
        
            if (currentId  < data[menu].length -1 ) {
                if (reviewList.indexOf((currentId + 1).toString()) !== -1) {
                    setReview(true);
                } else {
                    setReview(false);
                }
                setCurrentId(currentId + 1);
                setProgress((currentId) / (data[menu].length -2) * 100);
                setIsVisible(false);
                setMsg('');
            }
            initOption()

        
	};

	const [ value, setValue ] = useState('');

	const handleChange = (event) => {
		setValue(event.target.value);
	};

	const radio = (options) => {
		return (
			<FormControl component="fieldset">
				<RadioGroup aria-label="gender" name="gender1" value={value} onChange={handleChange}>
					{Object.keys(options).map((key, i) => (
						<FormControlLabel value={key} control={<Radio />} label={options[key]} key={i} />
					))}
				</RadioGroup>
			</FormControl>
		);
    };
    
    const initOption = () =>{
        setValue('')
        setState({A: false,
		B: false,
		C: false,
		D: false,
		E: false,
		F: false,
		G: false,
		H: false,
		I: false
	})
    }

	const [ state, setState ] = useState({
		A: false,
		B: false,
		C: false,
		D: false,
		E: false,
		F: false,
		G: false,
		H: false,
		I: false
	});

	const getVar = (opt) => {
		switch (opt) {
			case 'A':
				return A;
			case 'B':
				return B;
			case 'C':
				return C;
			case 'D':
				return D;
			case 'E':
				return E;
			case 'F':
				return F;
			case 'G':
				return G;
			case 'H':
				return H;
			case 'I':
				return I;
		}
	};
	const { A, B, C, D, E, F, G, H, I } = state;
	const handleChk = (event) => {
		setState({ ...state, [event.target.name]: event.target.checked });
	};
	const chk = (options) => {
		return Object.keys(options).map((key, i) => (
			<FormControlLabel
				control={<Checkbox checked={getVar(key)} onChange={handleChk} name={key} />}
				label={`${key} : ${options[key]}`}
				key={i}
			/>
		));
	};

	const [ msg, setMsg ] = useState('');
	const answerChk = (correctAnswer) => {
		const correctAnswerList = correctAnswer.split('');
		const templateList = {
			A: false,
			B: false,
			C: false,
			D: false,
			E: false,
			F: false,
			G: false,
			H: false,
			I: false
		};
		correctAnswerList.map((a) => (templateList[a] = true));
		let boolList = [];
		Object.keys(state).map((s) => boolList.push(state[s] === templateList[s]));
		if (boolList.indexOf(false) === -1) {
			setMsg('Correct!😊');
			setIsVisible(true);
		} else {
			setMsg('Wrong...😢');
			setIsVisible(true);
		}
	};

	const answerRadio = (answer) => {
		if (answer === value) {
			setMsg('Correct!😊');
			setIsVisible(true);
		} else {
			setMsg('Wrong...😢');
			setIsVisible(true);
		}
	};

	const content = (i) => {
        const quiz = data[menu][i]
		return (
			<div key={quiz.id} className="securityPlus-content">
				<LinearProgressWithLabel value={progress} />
				<small>Question {parseInt(quiz.id) + 1}</small>

				<h3>{quiz.question}</h3>
				<br />
				<div className="sp-options">
					{quiz.answer.length > 1 ? chk(quiz.options) : radio(quiz.options)}
				</div>
				<br />
				{quiz.answer.length > 1 ? (
					<Button onClick={() => answerChk(quiz.answer)}>Open Answer</Button>
				) : (
					<Button onClick={() => answerRadio(quiz.answer)}>Open Answer</Button>
				)}
				<h2>
					{msg}
					{isVisible ? ` Answer: ${quiz.answer}` : null}
				</h2>
				<div className="d-flex flex-row review-container">
					<Review list={reviewList} />
					<FormControlLabel
						control={
							<Checkbox
								checked={review}
								onChange={(e) => handleReviewChange(e, quiz.id)}
								name="review"
							/>
						}
						label="I will review this later."
						className="ml-3"
					/>
				</div>
			</div>
		);
	};

	const handleKeys = (key) => {
		switch (key) {
			case 'left':
				prev();
				break;
			case 'right':
				next();
				break;
		}
	};


	return (
		<Fragment>
			<div className="securityPlus-wrapper">
				<KeyboardEventHandler handleKeys={[ 'right', 'left' ]} onKeyEvent={(key, e) => handleKeys(key)} />
    {Object.keys(data).map(key =><Button onClick={()=>handleMenu(key)}>{key}</Button>)}
				<div className="securityPlus-container">
					<img src={logo} className="sp-logo" />
					<div className="securityPlus-box">
						<Grid container spacing={3}>
							<Grid item xs={1}>
								<IconButton onClick={() => prev()}>
									<NavigateBeforeIcon />
								</IconButton>
							</Grid>
							<Grid item xs={10}>
								{content(currentId)}
							</Grid>
							<Grid item xs={1}>
								<IconButton onClick={() => next()}>
									<NavigateNextIcon />
								</IconButton>
							</Grid>
						</Grid>
					</div>
				</div>
			</div>
		</Fragment>
	);
};

export default App;
